// auth.service.ts
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isExistingCustomer = false;

  constructor(private cookieService: CookieService) {}

  checkAuthkeyCookie(): string | null {
    const authkeyCookie = this.cookieService.get('authKey');
    return authkeyCookie ? authkeyCookie : null;
  }

  setExistingCustomer(value: boolean): void {
    this.isExistingCustomer = value;
  }

  isExistingCustomerMode(): boolean {
    return this.isExistingCustomer;
  }

  getAuthToken(): string | null {
    let token = this.cookieService.get('authKey');
    if (!token) {
      token = localStorage.getItem('authToken');
    }
    return token || null;
  }
}
